import React from "react";

/** A page's h1 with an optional line beneath it. */
const PageHeading: React.FunctionComponent<{
  title: React.ReactNode;
  sub?: React.ReactNode;
  className?: string;
}> = ({ title, sub, className }) => (
  <div className={className}>
    <h1 className="text-2xl font-bold leading-tight text-primary-3">{title}</h1>
    {sub ? <p className="mt-0.5 text-sm text-gray-500">{sub}</p> : null}
  </div>
);

export default PageHeading;
